import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  forwardRef,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { debounceTime, distinctUntilChanged, take, takeUntil } from 'rxjs';
import { CAConstants } from 'src/core/constants/ca-constant';
import { AutoUnsubscribe } from 'src/core/decorators/auto-unsubscribe.decorator';
import { RoleDto } from 'src/core/models/shared/role.dto';
import { CrudService } from 'src/core/services/crud/crud.service';
import { BaseDropdownSelectorComponent } from 'src/ui/base-selector/base-selector.module';

@Component({
    selector: 'ca-role-selector',
    templateUrl: './role-selector.component.html',
    styleUrl: './role-selector.component.scss',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: forwardRef(() => RoleSelectorComponent),
        },
    ],
    standalone: false
})
@AutoUnsubscribe()
export class RoleSelectorComponent
  extends BaseDropdownSelectorComponent<RoleDto>
  implements OnInit, AfterViewInit, OnDestroy, ControlValueAccessor
{
  @Input()
  set cls(classList: string) {
    this.classListArray.push(...classList.split(' '));
  }

  @Input()
  removePagination: boolean = false;

  constructor(
    protected elementRef: ElementRef,
    protected ngZone: NgZone,
    private service: CrudService
  ) {
    super(elementRef, ngZone);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  ngAfterViewInit(): void {
    this.quickSearchTermInput$
      .pipe(takeUntil(this.autoUnsubscribeNotifier), debounceTime(250), distinctUntilChanged())
      .subscribe(val => {
        this.pageIndex = 0;
        this.quickSearchTerm = val ?? '';

        if (
          0 < this.quickSearchTerm.length &&
          this.quickSearchTerm.length < CAConstants.SEARCH_INPUT_MIN_LENGTH
        ) {
          return;
        }

        this.load();
      });
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  compareFn(a: RoleDto, b: RoleDto): boolean {
    return a.id === b.id;
  }

  isSelected(item: RoleDto): boolean {
    return this.value && Array.isArray(this.value) && this.value.some(x => x.id == item.id);
  }

  protected load(): void {
    this.loading = true;

    this.service
      .abpGet<RoleDto>(
        RoleDto,
        {
          filters: [],
          sorters: [],
          maxResultCount: 999,
          skipCount: 0,
        },
        this.quickSearchTerm,
        'Name'
      )
      .pipe(take(1))
      .subscribe(response => {
        this.totalCount = response.totalCount;
        this.items = response.items;

        this.loading = false;
      });
  }
}
